<template>
  <ContentWrap>
    <el-form :model="query" inline>
      <el-form-item label="用户">
        <DigitalCardLookupSelect v-model="query.userId" placeholder="请选择用户" class="!w-220px" />
      </el-form-item>
      <el-form-item label="名片名称">
        <el-input v-model="query.cardName" clearable placeholder="模糊搜索" class="!w-160px" />
      </el-form-item>
      <el-form-item label="分享码">
        <el-input v-model="query.shareCode" clearable placeholder="模糊搜索" class="!w-180px" />
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="query.status" clearable class="!w-120px">
          <el-option
            v-for="(label, value) in DIGITAL_CARD_STATUS_LABELS"
            :key="value"
            :label="label"
            :value="Number(value)"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="默认卡">
        <el-select v-model="query.isDefault" clearable class="!w-100px">
          <el-option label="是" :value="true" />
          <el-option label="否" :value="false" />
        </el-select>
      </el-form-item>
      <el-form-item label="创建时间">
        <el-date-picker
          v-model="timeRange"
          type="datetimerange"
          value-format="YYYY-MM-DD HH:mm:ss"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="search">查询</el-button>
        <el-button @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>

  <ContentWrap>
    <el-table v-loading="loading" :data="list">
      <el-table-column label="用户" min-width="140">
        <template #default="scope">
          <div>{{ displayUser(scope.row) }}</div>
          <div v-if="scope.row.userMobile" class="text-12px text-[var(--el-text-color-secondary)]">
            {{ scope.row.userMobile }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="cardName" label="名片名称" min-width="140" />
      <el-table-column label="皮肤" width="100">
        <template #default="scope">{{ themeLabel(scope.row) }}</template>
      </el-table-column>
      <el-table-column label="默认卡" width="80" align="center">
        <template #default="scope">
          <el-tag v-if="scope.row.isDefault" size="small" type="warning">默认</el-tag>
          <span v-else class="text-[var(--el-text-color-secondary)]">-</span>
        </template>
      </el-table-column>
      <el-table-column label="分享码" min-width="160">
        <template #default="scope">
          <span class="font-mono text-12px">{{ scope.row.shareCode || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="90">
        <template #default="scope">{{ DIGITAL_CARD_STATUS_LABELS[scope.row.status] || '-' }}</template>
      </el-table-column>
      <el-table-column label="浏览" width="80" align="right">
        <template #default="scope">{{ countOf(scope.row, 'viewCount') }}</template>
      </el-table-column>
      <el-table-column label="分享" width="80" align="right">
        <template #default="scope">{{ countOf(scope.row, 'shareCount') }}</template>
      </el-table-column>
      <el-table-column label="保存" width="80" align="right">
        <template #default="scope">{{ countOf(scope.row, 'saveCount') }}</template>
      </el-table-column>
      <el-table-column label="发布时间" width="170">
        <template #default="scope">{{ displayDate(scope.row.publishTime) }}</template>
      </el-table-column>
      <el-table-column label="操作" width="200" fixed="right">
        <template #default="scope">
          <el-button link type="primary" @click="openDetail(scope.row.id)">详情</el-button>
          <!-- 预览：H5 直开 uni-app 页面路径无法落地，暂不提供 -->
          <!-- <el-button link type="primary" @click="openPreview(scope.row)">预览</el-button> -->
          <el-button
            v-if="scope.row.status === 0"
            v-hasPermi="['bosscircle:digital-card:audit']"
            link
            type="success"
            @click="audit(scope.row, 1)"
          >
            发布
          </el-button>
          <el-button
            v-if="scope.row.status === 1"
            v-hasPermi="['bosscircle:digital-card:audit']"
            link
            type="danger"
            @click="audit(scope.row, 2)"
          >
            停用
          </el-button>
          <el-button
            v-if="scope.row.status === 2"
            v-hasPermi="['bosscircle:digital-card:audit']"
            link
            type="success"
            @click="audit(scope.row, 1)"
          >
            恢复
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-model:page="query.pageNo"
      v-model:limit="query.pageSize"
      :total="total"
      @pagination="load"
    />
  </ContentWrap>

  <Dialog v-model="detailVisible" title="微名片详情" width="820px">
    <el-descriptions v-if="detail" :column="2" border>
      <el-descriptions-item label="用户">
        {{ displayUser(detail) }}
        <span v-if="detail.userMobile">（{{ detail.userMobile }}）</span>
      </el-descriptions-item>
      <el-descriptions-item label="用户ID">{{ detail.userId }}</el-descriptions-item>
      <el-descriptions-item label="名片名称">{{ detail.cardName || '-' }}</el-descriptions-item>
      <el-descriptions-item label="状态">{{ DIGITAL_CARD_STATUS_LABELS[detail.status] || '-' }}</el-descriptions-item>
      <el-descriptions-item label="皮肤">{{ themeLabel(detail) }}</el-descriptions-item>
      <el-descriptions-item label="默认卡">{{ detail.isDefault ? '是' : '否' }}</el-descriptions-item>
      <el-descriptions-item label="副职位">{{ detail.titleSecondary || '-' }}</el-descriptions-item>
      <el-descriptions-item label="版本">{{ detail.version ?? 0 }}</el-descriptions-item>
      <el-descriptions-item label="分享码" :span="2">
        <span class="font-mono">{{ detail.shareCode || '-' }}</span>
        <el-button v-if="detail.shareCode" link type="primary" class="ml-8px" @click="copyText(detail.shareCode)">
          复制
        </el-button>
        <!-- 与列表预览相同：H5 直开 uni-app 页面路径无法落地 -->
        <!-- <el-button link type="primary" class="ml-4px" @click="openPreview(detail)">打开 C 端预览</el-button> -->
      </el-descriptions-item>
      <el-descriptions-item label="浏览">{{ countOf(detail, 'viewCount') }}</el-descriptions-item>
      <el-descriptions-item label="分享">{{ countOf(detail, 'shareCount') }}</el-descriptions-item>
      <el-descriptions-item label="保存">{{ countOf(detail, 'saveCount') }}</el-descriptions-item>
      <el-descriptions-item label="发布时间">{{ displayDate(detail.publishTime) }}</el-descriptions-item>
      <el-descriptions-item label="展示字段" :span="2">
        <el-tag
          v-for="item in detail.whitelistFields || []"
          :key="item"
          size="small"
          class="mr-6px mb-6px"
        >
          {{ whitelistLabel(item) }}
        </el-tag>
        <span v-if="!(detail.whitelistFields || []).length" class="text-[var(--el-text-color-secondary)]">未配置</span>
      </el-descriptions-item>
      <el-descriptions-item label="企业字段锁定" :span="2">
        <el-switch
          v-model="detail.companyFieldsLocked"
          v-hasPermi="['bosscircle:digital-card:audit']"
          active-text="已锁定"
          inactive-text="未锁定"
          @change="toggleCompanyLock"
        />
        <span class="ml-8px text-12px text-[var(--el-text-color-secondary)]">
          锁定后用户不可在 C 端修改公司相关字段
        </span>
      </el-descriptions-item>
      <el-descriptions-item label="创建时间">{{ displayDate(detail.createTime) }}</el-descriptions-item>
      <el-descriptions-item label="更新时间">{{ displayDate(detail.updateTime) }}</el-descriptions-item>
    </el-descriptions>
  </Dialog>
</template>

<script setup lang="ts">
import { formatDate } from '@/utils/formatTime'
import * as DigitalCardApi from '@/api/digital-card'
import type { DigitalCardVO } from '@/api/digital-card'
import DigitalCardLookupSelect from './components/DigitalCardLookupSelect.vue'
import {
  DIGITAL_CARD_STATUS_LABELS,
  DIGITAL_CARD_THEME_LABELS,
  DIGITAL_CARD_WHITELIST_LABELS
} from './constants'

defineOptions({ name: 'BossCircleDigitalCard' })

const message = useMessage()
const loading = ref(false)
const list = ref<DigitalCardVO[]>([])
const total = ref(0)
const timeRange = ref<string[]>([])
const detailVisible = ref(false)
const detail = ref<DigitalCardVO>()
const query = reactive({
  pageNo: 1,
  pageSize: 10,
  userId: undefined as number | undefined,
  cardName: '',
  shareCode: '',
  isDefault: undefined as boolean | undefined,
  status: undefined as number | undefined
})

function countOf(row: Record<string, any> | undefined, key: string): number {
  if (!row) return 0
  const raw = row[key] ?? row[key.replace(/Count$/, '_count')]
  const n = Number(raw)
  return Number.isFinite(n) ? n : 0
}

function themeLabel(row?: DigitalCardVO | string) {
  if (!row) return '-'
  if (typeof row === 'string') return DIGITAL_CARD_THEME_LABELS[row] || row
  return row.themeName || DIGITAL_CARD_THEME_LABELS[row.theme || ''] || row.theme || '-'
}

function whitelistLabel(key: string) {
  return DIGITAL_CARD_WHITELIST_LABELS[key] || key
}

function displayUser(row?: DigitalCardVO) {
  if (!row) return '-'
  if (row.userNickname) return row.userNickname
  if (row.userId) return `用户${row.userId}`
  return '-'
}

function displayDate(value?: string | number) {
  return formatDate(value) || '-'
}

async function load() {
  loading.value = true
  try {
    const data = await DigitalCardApi.getDigitalCardPage({
      ...query,
      cardName: query.cardName || undefined,
      shareCode: query.shareCode || undefined,
      beginTime: timeRange.value?.[0],
      endTime: timeRange.value?.[1]
    })
    list.value = data.list || []
    total.value = data.total || 0
  } finally {
    loading.value = false
  }
}

function search() {
  query.pageNo = 1
  load()
}

function resetQuery() {
  query.userId = undefined
  query.cardName = ''
  query.shareCode = ''
  query.isDefault = undefined
  query.status = undefined
  timeRange.value = []
  search()
}

async function openDetail(id: number) {
  detail.value = await DigitalCardApi.getDigitalCard(id)
  detailVisible.value = true
}

// function openPreview(row: DigitalCardVO) {
//   if (!row.userId) return
//   window.open(buildMobileCardUrl(row.userId, row.shareCode), '_blank')
// }

async function copyText(text: string) {
  try {
    await navigator.clipboard.writeText(text)
    message.success('已复制')
  } catch {
    message.warning('复制失败，请手动复制')
  }
}

async function audit(row: DigitalCardVO, status: number) {
  const tips =
    status === 1 && row.status === 0
      ? '确认审核并发布该名片吗？'
      : status === 1 && row.status === 2
        ? '确认恢复发布该名片吗？'
        : '确认停用该名片吗？'
  await message.confirm(tips)
  try {
    await DigitalCardApi.auditDigitalCard({ id: row.id, version: row.version, status })
    message.success('操作成功')
    if (detail.value?.id === row.id) {
      detail.value = await DigitalCardApi.getDigitalCard(row.id)
    }
    await load()
  } catch (error: any) {
    const msg = String(error?.msg || error?.message || '')
    if (/version|版本|冲突|变化|刷新后重试|concurrent|CAS/i.test(msg)) {
      message.error('名片已被他人修改，请刷新后重试')
      await load()
      return
    }
    message.error(msg || '操作失败')
  }
}

async function toggleCompanyLock(value: boolean) {
  if (!detail.value) return
  try {
    await DigitalCardApi.updateDigitalCardCompanyLock({
      id: detail.value.id,
      companyFieldsLocked: value
    })
    message.success(value ? '已锁定企业字段' : '已解锁企业字段')
  } catch {
    detail.value.companyFieldsLocked = !value
  }
}

onMounted(load)
</script>
